import React, { useEffect, useLayoutEffect, useState } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import EbuCbuPieChartHbb from "./eBuCbuPieChartHbb";
import TraingleChartConsumer from "./traingleColumnChartConsumer";

am4core.useTheme(am4themes_animated);

export default function PieChartHbb({
  showEbuCbu,
  setShowEbuCbu,
  showColumnChart,
  setShowColumnChart,
  onNext,
  label,
  total,
}) {
  useLayoutEffect(() => {
    const chart = am4core.create("chartdiv94", am4charts.PieChart);
    chart.hiddenState.properties.opacity = 0; // this makes initial fade in effect

    chart.data = label;

    // Add and configure Series
    var pieSeries = chart.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "litres";
    pieSeries.dataFields.category = "country";

    // Let's cut a hole in our Pie chart the size of 40% the radius
    chart.innerRadius = am4core.percent(40);

    // Set up fills
    pieSeries.slices.template.fillOpacity = 1;

    pieSeries.slices.template.events.on("hit", function (ev) {
      console.log("PieSeries onClick", ev.target.dataItem);
      if (ev.target.dataItem.properties.category == "Government") return;
      onNext(ev.target.dataItem.properties.category);
    });

    var hs = pieSeries.slices.template.states.getKey("hover");
    hs.properties.scale = 1;
    hs.properties.fillOpacity = 0.5;

    if (total) {
      let totalLabel = chart.createChild(am4core.Label);
      totalLabel.text = `Total: ${total}`;
      totalLabel.fontSize = 20;
      totalLabel.align = "center";
      totalLabel.isMeasured = false;
      totalLabel.x = am4core.percent(50);
      totalLabel.horizontalCenter = "middle";
      totalLabel.y = am4core.percent(46);
      totalLabel.clickable = true;
      totalLabel.events.on("hit", () => (total > 0 ? onNext("All") : null));
      totalLabel.cursorOverStyle = am4core.MouseCursorStyle.pointer;
    }

    return () => {
      chart.dispose();
    };
  }, []);

  if (showColumnChart) {
    return <TraingleChartConsumer />;
  }

  if (showEbuCbu) {
    return (
      <EbuCbuPieChartHbb
        category={showEbuCbu}
        onClick={() => setShowColumnChart(true)}
      />
    );
  }

  return (
    <div
      id="chartdiv94"
      style={{ width: "100%", height: "500px", direction: "ltr" }}
    />
  );
}
